import eComicSeries_alpha0 from "../assets/00-eComic-series_4x.png";
import tomowellogo from "../assets/logo.svg";

import compare_01 from "../assets/02_newsize.jpg";
import compare_02 from "../assets/03_newsize_ecsPlus.jpg";
import ie_moire from "../assets/03_ie_moire.jpg";

export const eComicSeriesAlpha0 = eComicSeries_alpha0;

export const tomowelLogo = tomowellogo;

export const compare01 = compare_01;
export const compare02 = compare_02;

export const ieMoire = ie_moire;